import styled, { keyframes } from 'styled-components';
import { useState, useEffect } from 'react';

const slideIn = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const slideOut = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(100%);
    opacity: 0;
  }
`;

const ModalWrapper = styled.div<{ isClosing: boolean }>`
  position: fixed;
  bottom: 200px;
  right: 300px;
  z-index: 1000;
  animation: ${({ isClosing }) => isClosing ? slideOut : slideIn} 0.5s ease-in-out;
`;

const ModalContent = styled.div`
  background-color: #2282E9;
  padding: 20px 40px;
  border-radius: 10px;
  color: white;
  font-size: 16px;
  font-weight: 500;
`;

interface SuccessModalProps {
  onClose: () => void;
}

export const TemporarySaveSuccessModal = ({ onClose }: SuccessModalProps) => {
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    // 2.5초 후 닫기 애니메이션 시작
    const closeTimer = setTimeout(() => {
      setIsClosing(true);
    }, 2500);

    // 3초 후 모달 완전히 제거
    const removeTimer = setTimeout(() => {
      onClose();
    }, 3000);

    return () => {
      clearTimeout(closeTimer);
      clearTimeout(removeTimer);
    };
  }, [onClose]);

  return (
    <ModalWrapper isClosing={isClosing}>
      <ModalContent>
        임시저장이 완료되었습니다.
      </ModalContent>
    </ModalWrapper>
  );
}; 